import { compose } from 'recompose'
import { connect } from 'react-redux'
import {
  selectCorporateProfile,
  selectCustomerProfile
} from 'src/store/selectors/customerProfile'

const DisclaimerContainer = compose(
  connect(state => {
    const corporateProfile = selectCorporateProfile(state) || {}
    const {
      address,
      showAddress,
      logoLightUri,
      name,
      phone,
      equalHousingType,
      kind,
      nmls
    } = corporateProfile
    const customerProfile = selectCustomerProfile(state) || {}

    return {
      companyAddress: showAddress && address ? address : null,
      companyLogo: logoLightUri,
      companyName: name,
      companyPhone: phone,
      customerDisclaimer: customerProfile.disclaimer,
      equalHousingType,
      nmls: kind === 'mortgage_lending_company' && nmls ? nmls : null
    }
  })
)

export default DisclaimerContainer
